module.exports = "/_next/static/images/Prakarsh2-9bbb1e0b45c1bbb2dc16ecd70ae55739.jpg";